import { ProviderClient } from '../../abstract/provider.client'
import { PROPERTY_APP_SESSION } from '../../abstract/provider.objects'
import { ProviderHttpCommon } from '../common'

export const ProviderHTTPClient: ProviderClient = {
  key: ProviderHttpCommon.key,
  description: {
    icon: <i className="las la-wifi" style={{ fontSize: '20px' }}></i>,
    label: 'HTTP',
    triggers: [
      {
        key: 'newRequest',
        label: 'New Request',
        output: [PROPERTY_APP_SESSION],
        input: [
          {
            key: 'eventKey',
            propsFormItem: {
              label: 'Event Key',
            },
          },
        ],
      },
    ],
    actions: [],
  },
}
